import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  authSlice,
  ccb14Slice,
  logoutSlice,
  contractPDFSlice,
  additionalInfoSlice,
} from "./slice";
import uploadedReqDocs from "./slice/uploadedDocs";

export const store = configureStore({
  reducer: combineReducers({
    authenticators: authSlice.reducer,
    logoutModal: logoutSlice.reducer,
    ccb14: ccb14Slice.reducer,
    contractPDFs: contractPDFSlice.reducer,
    additionalInfoPageInitialState: additionalInfoSlice.reducer,
    uploadedReqDocs,
  }),
});

export default store;
